export default "__VITE_ASSET__2c387108__"